import { IntlShape } from 'react-intl';

export const getPaymentDetailsLabels = (itemName: string, intl: IntlShape, isCreditsPayment?: boolean) => {
  if (isCreditsPayment) {
    return {
      itemName,
    };
  }

  return {
    itemName,
    subtotal: intl.formatMessage({ id: 'subtotal' }),
    tax: intl.formatMessage({ id: 'tax' }),
    total: intl.formatMessage({ id: 'total' }),
    credits: intl.formatMessage({ id: 'credits_applied' }),
    discount: intl.formatMessage({ id: 'discount' }),
  };
};
